import { SPACINGS, TRANSITIONS } from 'shared/styles/variables';
import styled from 'styled-components';

/**
 * Form layout helper to properly style form control labels.
 * Mirrored from the shared `FormGroup` component. This is the Dashboard
 * specific version.
 *
 * TODO: PER-1771 Remove margin-bottom once all forms are migrated. Spacing
 * should be handled by the grid layout.
 */
const FormGroup = styled('div')`
  margin-bottom: ${SPACINGS.base * 3}px;

  label {
    transition: ${TRANSITIONS.fast};
  }
`;

export default FormGroup;
